import React, { useState, useEffect } from 'react';
import ChatbotWordLookup from './ChatbotWordLookup';
import ChatbotKanjiLookup from './ChatbotKanjiLookup';
import ChatbotChineseLookup from './ChatbotChineseLookup';
import './ChatbotDictionary.css';
import logger from '../utils/logger';

const ChatbotDictionaryPanel = ({ selectedWord, sentence, language, baseLanguage }) => {
    const [isJapanese, setIsJapanese] = useState(false);
    const [isChinese, setIsChinese] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsJapanese(language === 'Japanese');
        setIsChinese(language === 'Chinese');
        setError(null);

        logger.debug(`ChatbotDictionaryPanel - Language: ${language}, Word: "${selectedWord || 'none'}", Sentence: "${sentence || 'none'}"`);
    }, [language, selectedWord, sentence]);

    const handleError = (errorMsg) => {
        setError(errorMsg);
        logger.error("ChatbotDictionaryPanel - Error:", errorMsg);
    };

    if (!selectedWord) {
        return (
            <div className="chatbot-dictionary-empty">
                <p>Click on a word in Bojee's messages to see its definition.</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="chatbot-error-container">
                <div className="chatbot-error-text">Error: {error}</div>
                <div className="chatbot-error-note">
                    There was a problem loading the dictionary information. Please try again later.
                </div>
            </div>
        );
    }

    return (
        <div className="chatbot-dictionary-word-details">
            {isJapanese ? (
                <div className="chatbot-dictionary-kanji-container">
                    <ChatbotKanjiLookup
                        word={selectedWord}
                        sentence={sentence}
                        onSelectWord={null}
                    />
                </div>
            ) : isChinese ? (
                <div className="chatbot-dictionary-chinese-container">
                    <ChatbotChineseLookup
                        word={selectedWord}
                        sentence={sentence}
                        onSelectWord={null}
                        baseLanguage={baseLanguage}
                    />
                </div>
            ) : (
                <div className="chatbot-dictionary-word-container">
                    <ChatbotWordLookup
                        word={selectedWord}
                        language={language}
                        sentence={sentence}
                        onSelectWord={null}
                        baseLanguage={baseLanguage}
                    />
                </div>
            )}
        </div>
    );
};

export default ChatbotDictionaryPanel;